import { FormArray, FormGroup } from "@angular/forms";
import { Hook } from "../../../models/hook.model";
import { logTimeOf } from "../../../flights2.pipes";
import { amount, hours, id } from "../../form/controls";

/** What this flight used of a hook: its cycles and hours, never its totals. */
export function buildHookArray(hooks: Hook[]) {
    return new FormArray(hooks.map((hook) => new FormGroup({ id: id(hook.id), cycles: amount(hook.cycles), hours: hours(logTimeOf(hook.hours) || null) })));
}

export type HookArray = ReturnType<typeof buildHookArray>;
